import React from "react";

const Otp_in = () => {
  return (
    <div>
      Customers opt in to receive SMS messages by entering their phone number on
      our website and checking a box that confirms their consent to receive text
      messages. The form clearly explains that message and data rates may apply,
      and they can reply STOP to unsubscribe.
    </div>
  );
};

export default Otp_in;
